export const DEFAULT_INDICATOR_ID = 'IND19';
export const DEFAULT_STEP_ID = 'PH99';